export type ThemeMode = 'light' | 'dark';

export type BrandTokens = {
  accent: string;
  accentSoft: string;
  secondary: string;
  appBg: string;
  fgPrimary: string;
  bannerBg: string;
  bannerFg: string;
  sidebarBg: string;
  submenuBg: string;
  sidebarFg: string;
  sidebarFgSelected: string;
  sidebarDivider: string;
};

export const brand: Record<ThemeMode, BrandTokens> = {
  light: {
    accent: '#df1b12',
    accentSoft: '#e16a64',
    secondary: '#004b7f',
    appBg: '#f8f8f8',
    fgPrimary: '#000',
    bannerBg: '#2c2c2c',
    bannerFg: '#1f2328',
    sidebarBg: '#ffffff',
    submenuBg: '#ffffff',
    sidebarFg: 'rgba(0, 0, 0, 0.67)',
    sidebarFgSelected: '#000',
    sidebarDivider: 'rgba(31, 35, 40, 0.12)',
  },
  dark: {
    accent: '#ff6b63',
    accentSoft: '#ff8c86',
    secondary: '#00aaff',
    appBg: '#333333',
    fgPrimary: '#fff',
    bannerBg: '#1f2328',
    bannerFg: '#f5f7fa',
    sidebarBg: '#1f2328',
    submenuBg: '#262c34',
    sidebarFg: 'rgba(255, 255, 255, 0.67)',
    sidebarFgSelected: '#fff',
    sidebarDivider: 'rgba(245, 247, 250, 0.14)',
  },
};

export const fonts = {
  display: "'Gilroy', ui-sans-serif, system-ui, sans-serif",
  body: "'Proxima Nova', ui-sans-serif, system-ui, sans-serif",
  bodyBold: "'Proxima Nova', ui-sans-serif, system-ui, sans-serif",
};

export const radiusMd = '5px';
